export enum SerpFeatureSet1Gq {
  none = 0,
  answer_box = 1,
  app = 2,
  carousel = 4,
  commercial_units = 8,
  currency_box = 16,
  events = 32,
  featured_snippet = 64,
  find_results_on = 128,
  found_on_the_web = 256,
  google_flights = 512,
  google_hotels = 1024,
  google_posts = 2048,
  google_reviews = 4096,
  hotels_pack = 8192,
  images = 16384,
  jobs = 32768,
  knowledge_graph = 65536,
  local_pack = 131072,
  local_services = 262144,
  map = 524288,
  math_solver = 1048576,
  mention_carousel = 2097152,
  multi_carousel = 4194304,
  organic = 8388608,
  paid = 16777216,
  people_also_ask = 33554432,
  people_also_search = 67108864,
  podcasts = 134217728,
  popular_products = 268435456,
  questions_and_answers = 536870912,
  recipes = 1073741824,
}
